import OutdoorsGearInsiderLogo from './logo'
import {outdoorsGearInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'outdoorsgearinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Outdoors Gear Insider',
  logo: <OutdoorsGearInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/outdoorsgearinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-X2B7XJBKSX',
    camelCaseUrl: 'OutdoorsGearInsider.com',
    title: (category: string, count: string) => `Outdoor Insider | Top ${count} Pro Insider Choices for ${category}`,
    description: (_category?: string, count?: string) =>
      `Your next adventure starts here. Top ${count} gear essentials, field-tested. Uncover the gear that survives, thrives. Insider knowledge for the wild.`,
    styles: outdoorsGearInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
